import Color from 'color';

const userColors = ["#d92a2a", "#c2a800", "#2ad92a", "#2ad9d9", "#2a2ad9", "#d92ad9", "#2f4f4f", "#2e8b57", "#191970", "#8b0000", "#808000", "#ff0000", "#ff8c00", "#ffd700", "#7cfc00", "#ba55d3", "#e9967a", "#00ffff", "#ff00ff", "#1e90ff", "#eee8aa", "#dda0dd", "#ff1493", "#71d271", "#87cefa"];
const getTextColor = (color) => {
  try {
    const c = Color(color);
    const r = c.red();
    const g = c.green();
    const b = c.blue();
    const yiq = (r * 299 + g * 587 + b * 114) / 1e3;
    return yiq >= 140 ? "black" : "white";
  } catch {
    return "white";
  }
};
const getLightenedColor = (color, amount) => {
  try {
    const c = Color(color);
    const white = Color("white");
    const lightenedColor = c.mix(white, amount);
    return lightenedColor.hex();
  } catch {
    return color;
  }
};
const getTransparentColor = (color, amount) => {
  try {
    const c = Color(color);
    return c.alpha(amount).toString();
  } catch {
    return color;
  }
};
const getUserColorFromId = (sub) => {
  const index = (sub.charCodeAt(0) + sub.charCodeAt(sub.length - 1)) % userColors.length;
  const color = userColors[index];
  return color;
};
const getColorFromCssVar = (cssVar) => {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVar);
};
const isCssVar = (color) => {
  return color.startsWith("--");
};

export { getColorFromCssVar, getLightenedColor, getTextColor, getTransparentColor, getUserColorFromId, isCssVar };
//# sourceMappingURL=index.js.map
